const PropelLogo = ({ className = 'w-8 h-8' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" className={className}>
    <path d="M6 26L14 6L17 15L20 6L28 26L20 21L17 26L14 21Z" fill="#4F46E5" opacity="0.95" />
    <path d="M14 6L17 15L20 6L17 10Z" fill="#6366F1" />
  </svg>
);

export default PropelLogo;
